









































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AntecipacaoRecebiveisStore from '../financeiro/Store/AntecipacaoRecebiveisStore'

@Component
export default class AgendaGarantiaMinimaRightNavBar extends Vue {
  $refs!: {
    menuProxPagamentoInicio: any
    menuProxPagamentoFim: any
  }

  menuProxPagamentoInicio: boolean = false
  menuProxPagamentoFim: boolean = false
  filterLoading: boolean = false

  get getStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  get drawer() {
    return this.getStore.drawer
  }
  set drawer(value: boolean) {
    this.getStore.setDrawer(value)
  }

  get hospitaisList() {
    return this.getStore.locaisExecucaoList
  }

  get selectedHospital() {
    return this.getStore.selectedHospital
  }
  set selectedHospital(value) {
    this.getStore.setSelectedHospital(value)
  }

  get proxPagamentoInicio() {
    return this.getStore.proxPagamentoInicio
  }
  set proxPagamentoInicio(value) {
    this.getStore.setProxPagamentoInicio(value)
  }

  get proxPagamentoFim() {
    return this.getStore.proxPagamentoFim
  }
  set proxPagamentoFim(value) {
    this.getStore.setProxPagamentoFim(value)
  }

  async search() {
    this.filterLoading = true
    this.getStore.setPagina(1)
    this.getStore.getAllAntecipacoes()
    this.getStore.setFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }

  hasAnyFilter(): boolean {
    return (
      !!this.getStore.selectedHospital ||
      !!this.getStore.proxPagamentoInicio ||
      !!this.getStore.proxPagamentoFim
    )
  }

  async clear() {
    this.getStore.clearFiltroAvançado()
    this.getStore.setFilterOn(false)
    await this.search()
  }
}
